export enum AppointmentStatusCode {
  EXPIRED = 'EXPIRED',
  CONFIRMED = 'CONFIRMED',
  DECLINED = 'DECLINED',
  DECLINING = 'DECLINING',
  PENDING = 'PENDING'
}

export interface GetAppointmentResponse {
  clientName?: string;
  serviceName?: string;
  centerDetails?: string;
  appointmentDateTime?: string;
  appointmentId: string;
  appointmentDate?: string;
  appointmentTime?: string;
  clientAttendanceResponseStatus: AppointmentStatusCode;
  cancellationReasonCode?: AppointmentCancellationReason;
  cancellationOtherReason?: string;
}

export enum AppointmentClientResponse {
  DECLINED = 'DECLINED',
  CONFIRMED = 'CONFIRMED'
}

export enum AppointmentCancellationReason {
  HOSPITALISATION = 'HOSPITALISATION',
  CLIENT_UNWELL = 'CLIENT_UNWELL',
  CLIENT_PASSED_AWAY = 'CLIENT_PASSED_AWAY',
  OTHER = 'OTHER'
}

export interface UpdateAppointment {
  appointmentId?: string;
  clientResponse?: AppointmentClientResponse;
  clientResponseMethod: 'SMS';
  linkId: string;
  cancellationReason?: string;
  cancellationOtherReason?: string;
}

export interface AppointmentState {
  loading: boolean;
  data?: GetAppointmentResponse;
  showSomethingWentWrong?: boolean;
}
